import { render, staticRenderFns } from "./counter.vue.js?vue&type=template&id=4735ca82&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./counter.vue?vue&type=template&id=4735ca82&vue3"
import script from "./counter.vue.js?vue&type=script&lang=js&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./counter.vue?vue&type=script&lang=js&vue3"
export * from "./counter.vue.js?vue&type=script&lang=js&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./counter.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports